module.exports = __webpack_public_path__ + "img/icon_fault_error.40550004.png";